var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShevron = function SvgShevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 6,
    fill: "none",
    viewBox: "0 0 10 6"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D4D4D",
    d: "M5.06 5.68c.14.15.35.15.5 0l4.33-4.3c.15-.12.15-.36 0-.5L9.3.32c-.11-.15-.35-.15-.5 0L5.33 3.78 1.8.32a.34.34 0 0 0-.5 0L.73.88c-.15.14-.15.38 0 .5l4.34 4.3Z"
  })));
};
export default SvgShevron;